import { render } from "./Main.vue?vue&type=template&id=39f35f78"
const script = {}
script.render = render

export default script